// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentIndividualPage_wrapper__FsD0K","table":"DocumentIndividualPage_table__6RUFI"};